import { Endpoint, Entity, Property } from '@square/ignition';

const collectAllPropertiesForEntity = (
  entity: Entity,
  visitedEntitySet: Set<string>
): Array<Property> => {
  const properties: Array<Property> = [];
  if (visitedEntitySet.has(entity.id)) {
    return properties;
  }

  visitedEntitySet.add(entity.id);

  for (const prop of entity.properties) {
    properties.push(prop);
    if (prop.entity) {
      properties.push(
        ...collectAllPropertiesForEntity(prop.entity, visitedEntitySet)
      );
    } else if (prop.itemEntity) {
      properties.push(
        ...collectAllPropertiesForEntity(prop.itemEntity, visitedEntitySet)
      );
    }
  }

  return properties;
};

/**
 * For a given endpoint, converts all the properties
 * on the request body, path params, and query params into a
 * flattened array of properties.
 * @param endpoint The endpoint to collect properties on
 * @returns A flattened array of all properties. There may be duplicates.
 */
const collectAllPropertiesForEndpoint = (
  endpoint: Endpoint
): Array<Property> => {
  const properties: Array<Property> = [];

  if (endpoint.requestBody) {
    properties.push(
      ...collectAllPropertiesForEntity(endpoint.requestBody, new Set())
    );
  }

  if (endpoint.pathParameters) {
    properties.push(...endpoint.pathParameters);
  }

  if (endpoint.queryParameters) {
    properties.push(...endpoint.queryParameters);
  }

  return properties;
};

const convertPropertyArrayToNameSet = (
  properties: Array<Property>
): Set<string> => {
  const propertyNames = new Set<string>();
  for (const prop of properties) {
    propertyNames.add(prop.name);
  }

  return propertyNames;
};

export {
  collectAllPropertiesForEntity,
  collectAllPropertiesForEndpoint,
  convertPropertyArrayToNameSet,
};
